var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-item"},[_c('button-link',{attrs:{"underline":true},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.notice.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }